
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signUp, checkUsernameUniqueness, uploadProfilePhoto } from '../utils/actions/authActions';
import { FiCamera, FiEye, FiEyeOff, FiArrowLeft, FiArrowRight, FiCheck } from 'react-icons/fi';
import defaultUserProfilePicture from '../assets/Images/defaultUserProfilePicture.png';
import logo from '../assets/Images/logo.png';
import styles from './SignupPage.module.css';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { countries } from 'country-codes-flags-phone-codes';


const INDUSTRY_OPTIONS = [
  { label: "Music", value: "Music" },
  { label: "Comedy", value: "Comedy" }
];

const USER_TYPE_OPTIONS = {
  Music: [
    { label: "Artist", value: "Artist" },
    { label: "Crew", value: "Crew" },
    { label: "Manager", value: "Manager" },
    { label: "Vendor", value: "Vendor" },
    { label: "Staff", value: "Staff" },
    { label: "Oraganization", value: "Organization" }
  ],
  Comedy: [
    { label: "Artist", value: "Artist" },
    { label: "Crew", value: "Crew" },
    { label: "Manager", value: "Manager" },
    { label: "Staff", value: "Staff" },
    { label: "Oraganization", value: "Organization" }
  ]
};

const USER_SUBTYPE_OPTIONS = {
  Comedy: {
    Artist: [
      { label: "Comedy Writer", value: "Comedy Writer" },
      { label: "Improv Comedian", value: "Improv Comedian" },
      { label: "Sketch Artist", value: "Sketch Artist" },
      { label: "Stand-Up Comedian", value: "Stand-Up Comedian" },
    ],
    Crew: [
      { label: "Backline Technician", value: "Backline Technician" },
      { label: "Dresser", value: "Dresser" },
      { label: "Drum Tech", value: "Drum Tech" },
      { label: "FOH Engineer", value: "FOH Engineer" },
      { label: "Guitar Tech", value: "Guitar Tech" },
      { label: "IEM Engineer", value: "IEM Engineer" },
      { label: "Keyboard Tech", value: "Keyboard Tech" },
      { label: "Light Engineer", value: "Light Engineer" },
      { label: "Lighting Technician", value: "Lighting Technician" },
      { label: "Makeup Artist", value: "Makeup Artist" },
      { label: "Merchandiser", value: "Merchandiser" },
      { label: "Monitor Engineer", value: "Monitor Engineer" },
      { label: "Photographer", value: "Photographer" },
      { label: "Rigger", value: "Rigger" },
      { label: "Road Manager", value: "Road Manager" },
      { label: "Security Personnel", value: "Security Personnel" },
      { label: "Stage Manager", value: "Stage Manager" },
      { label: "Stage Tech", value: "Stage Tech" },
      { label: "Tour Bus Driver", value: "Tour Bus Driver" },
      { label: "Videographer", value: "Videographer" },
    ],
    Manager: [
      { label: "Tour Manager", value: "Tour Manager" },
      { label: "Artist Manager", value: "Artist Manager" },
    ],
    Vendor: [
      { label: "Backline Provider", value: "Backline Provider" },
      { label: "Light Vendor", value: "Light Vendor" },
      { label: "Sound Vendor", value: "Sound Vendor" },
      { label: "Stage and Production Vendor", value: "Stage and Production Vendor" },
    ],
  
    Staff: [
    // Backline Staff
    { label: "Backline Equipment Coordinator", value: "Backline Equipment Coordinator" },
    { label: "Instrument Maintenance Technician", value: "Instrument Maintenance Technician" },
    { label: "Backline Logistics Coordinator", value: "Backline Logistics Coordinator" },
    { label: "Equipment Setup Technician", value: "Equipment Setup Technician" },
  
    // Lighting Staff
    { label: "Lighting Setup Technician", value: "Lighting Setup Technician" },
    { label: "Lighting Board Operator", value: "Lighting Board Operator" },
    { label: "Lighting Rig Technician", value: "Lighting Rig Technician" },
    { label: "DMX Systems Specialist", value: "DMX Systems Specialist" },
    { label: "Moving Light Technician", value: "Moving Light Technician" },
  
    // Sound Staff
    { label: "PA System Technician", value: "PA System Technician" },
    { label: "Audio Setup Specialist", value: "Audio Setup Specialist" },
    { label: "Speaker Systems Technician", value: "Speaker Systems Technician" },
    { label: "Audio Equipment Coordinator", value: "Audio Equipment Coordinator" },
    { label: "FOH Systems Technician", value: "FOH Systems Technician" },
  
    // Stage and Production Staff
    { label: "Stage Construction Technician", value: "Stage Construction Technician" },
    { label: "Truss System Specialist", value: "Truss System Specialist" },
    { label: "Stage Equipment Coordinator", value: "Stage Equipment Coordinator" },
    { label: "Production Setup Coordinator", value: "Production Setup Coordinator" },
    { label: "Staging Logistics Specialist", value: "Staging Logistics Specialist" }
  ],
  Organization: [
    { label: "Artist Management Company", value: "Artist Management Company" },
  ],
},
Music: {
  Artist: [
    { label: "Bass Guitarist", value: "Bass Guitarist" },
    { label: "Cellist", value: "Cellist" },
    { label: "DJ", value: "DJ" },
    { label: "Dhol Player", value: "Dhol Player" },
    { label: "Dholak Player", value: "Dholak Player" },
    { label: "Drummer", value: "Drummer" },
    { label: "Flutist", value: "Flutist" },
    { label: "Ghatam Player", value: "Ghatam Player" },
    { label: "Guitarist", value: "Guitarist" },
    { label: "Harmonium Player", value: "Harmonium Player" },
    { label: "Keyboardist", value: "Keyboardist" },
    { label: "Mridangam Player", value: "Mridangam Player" },
    { label: "Music Producer", value: "Music Producer" },
    { label: "Percussionist", value: "Percussionist" },
    { label: "Rapper", value: "Rapper" },
    { label: "Santoor Player", value: "Santoor Player" },
    { label: "Sarod Player", value: "Sarod Player" },
    { label: "Saxophonist", value: "Saxophonist" },
    { label: "Shehnai Player", value: "Shehnai Player" },
    { label: "Sitar Player", value: "Sitar Player" },
    { label: "Tabla Player", value: "Tabla Player" },
    { label: "Trumpeter", value: "Trumpeter" },
    { label: "Veena Player", value: "Veena Player" },
    { label: "Violinist", value: "Violinist" },
    { label: "Vocalist", value: "Vocalist" },
  ],
  Crew: [
    { label: "Backline Technician", value: "Backline Technician" },
    { label: "Dresser", value: "Dresser" },
    { label: "Drum Tech", value: "Drum Tech" },
    { label: "FOH Engineer", value: "FOH Engineer" },
    { label: "Guitar Tech", value: "Guitar Tech" },
    { label: "IEM Engineer", value: "IEM Engineer" },
    { label: "Keyboard Tech", value: "Keyboard Tech" },
    { label: "Light Engineer", value: "Light Engineer" },
    { label: "Lighting Technician", value: "Lighting Technician" },
    { label: "Makeup Artist", value: "Makeup Artist" },
    { label: "Merchandiser", value: "Merchandiser" },
    { label: "Monitor Engineer", value: "Monitor Engineer" },
    { label: "Photographer", value: "Photographer" },
    { label: "Rigger", value: "Rigger" },
    { label: "Road Manager", value: "Road Manager" },
    { label: "Security Personnel", value: "Security Personnel" },
    { label: "Stage Manager", value: "Stage Manager" },
    { label: "Stage Tech", value: "Stage Tech" },
    { label: "Tour Bus Driver", value: "Tour Bus Driver" },
    { label: "Videographer", value: "Videographer" },
  ],
  Manager: [
    { label: "Tour Manager", value: "Tour Manager" },
    { label: "Artist Manager", value: "Artist Manager" },
  ],
  Vendor: [
    { label: "Backline Provider", value: "Backline Provider" },
    { label: "Light Vendor", value: "Light Vendor" },
    { label: "Sound Vendor", value: "Sound Vendor" },
    { label: "Stage and Production Vendor", value: "Stage and Production Vendor" },
  ],

  Staff: [
  // Backline Staff
  { label: "Backline Equipment Coordinator", value: "Backline Equipment Coordinator" },
  { label: "Instrument Maintenance Technician", value: "Instrument Maintenance Technician" },
  { label: "Backline Logistics Coordinator", value: "Backline Logistics Coordinator" },
  { label: "Equipment Setup Technician", value: "Equipment Setup Technician" },

  // Lighting Staff
  { label: "Lighting Setup Technician", value: "Lighting Setup Technician" },
  { label: "Lighting Board Operator", value: "Lighting Board Operator" },
  { label: "Lighting Rig Technician", value: "Lighting Rig Technician" },
  { label: "DMX Systems Specialist", value: "DMX Systems Specialist" },
  { label: "Moving Light Technician", value: "Moving Light Technician" },

  // Sound Staff
  { label: "PA System Technician", value: "PA System Technician" },
  { label: "Audio Setup Specialist", value: "Audio Setup Specialist" },
  { label: "Speaker Systems Technician", value: "Speaker Systems Technician" },
  { label: "Audio Equipment Coordinator", value: "Audio Equipment Coordinator" },
  { label: "FOH Systems Technician", value: "FOH Systems Technician" },

  // Stage and Production Staff
  { label: "Stage Construction Technician", value: "Stage Construction Technician" },
  { label: "Truss System Specialist", value: "Truss System Specialist" },
  { label: "Stage Equipment Coordinator", value: "Stage Equipment Coordinator" },
  { label: "Production Setup Coordinator", value: "Production Setup Coordinator" },
  { label: "Staging Logistics Specialist", value: "Staging Logistics Specialist" }
],
Organization: [
  { label: "Artist Management Company", value: "Artist Management Company" },
],
},
};
// Function to generate year options from 1950 to current year
const generateYearOptions = () => {
const currentYear = new Date().getFullYear();
const years = [];
for (let year = currentYear; year >= 1950; year--) {
years.push({ value: year, label: year.toString() });
}
return years;
};
// Function to get the verb based on subType
const getActivityVerb = (subType) => {
  const verbMap = {
    // Music
    "Vocalist": "singing",
    "DJ": "DJing",
    "Drummer": "drumming",
    "Guitarist": "playing guitar",
    "Bass Guitarist": "playing bass guitar",
    "Keyboardist": "playing keyboard",
    "Violinist": "playing violin",
    "Cellist": "playing cello",
    "Flutist": "playing flute",
    "Trumpeter": "playing trumpet",
    "Saxophonist": "playing saxophone",
    "Percussionist": "playing percussion",
    "Tabla Player": "playing tabla",
    "Sitar Player": "playing sitar",
    "Santoor Player": "playing santoor",
    "Sarod Player": "playing sarod",
    "Veena Player": "playing veena",
    "Dhol Player": "playing dhol",
    "Dholak Player": "playing dholak",
    "Ghatam Player": "playing ghatam",
    "Harmonium Player": "playing harmonium",
    "Mridangam Player": "playing mridangam",
    "Shehnai Player": "playing shehnai",
    "Rapper": "rapping",
    "Music Producer": "producing music",
    
    // Crew
    "FOH Engineer": "engineering live sound",
    "Light Engineer": "designing lighting",
    "IEM Engineer": "working with in-ear monitoring",
    "Monitor Engineer": "engineering stage monitors",
    "Stage Manager": "managing stages",
    "Drum Tech": "teching drums",
    "Guitar Tech": "teching guitars",
    "Keyboard Tech": "teching keyboards",
    "Backline Technician": "working with backline",
    "Lighting Technician": "working with lighting",
    "Rigger": "rigging",
    "Videographer": "videography",
    "Photographer": "photography",
    "Merchandiser": "merchandising",
    "Dresser": "styling artists",
    "Makeup Artist": "doing makeup",
    "Security Personnel": "working in security",
    "Road Manager": "road managing",
    "Tour Bus Driver": "driving tour buses",
    "Stage Tech": "working as stage tech",
    
    // Managers
    "Tour Manager": "tour managing",
    "Artist Manager": "artist managing",
    
    // Comedy
    "Comedy Writer": "writing comedy",
    "Improv Comedian": "doing improv comedy",
    "Sketch Artist": "creating sketches",
    "Stand-Up Comedian": "doing stand-up",
    
    // Default
    "default": "working in this field"
  };
  
  return verbMap[subType] || verbMap["default"];
};


// Filter and prepare country data for dropdown
const COUNTRY_CODES = countries.map(country => ({
  code: `+${country.phone}`,
  flag: country.flag,
  name: country.name
})).filter(country => country.code !== '+undefined');

// Sort countries alphabetically but with India (+91) first
const sortedCountryCodes = [
{ code: '+91', flag: '🇮🇳', name: 'India' },
...COUNTRY_CODES.filter(country => country.code !== '+91')
.sort((a, b) => a.name.localeCompare(b.name))
];


const SignupPage = () => {
const navigate = useNavigate();
const [currentStep, setCurrentStep] = useState(1);
const [showPassword, setShowPassword] = useState(false);
const [error, setError] = useState('');
const [isLoading, setIsLoading] = useState(false);
const [showCountryDropdown, setShowCountryDropdown] = useState(false);
// State for phone verification
const [phoneNumber, setPhoneNumber] = useState('');
const [selectedCountry, setSelectedCountry] = useState(sortedCountryCodes[0]); // Default to India
const [otp, setOtp] = useState(['', '', '', '', '', '']);
const otpInputRefs = useRef([]);
const countryDropdownRef = useRef(null);
const phoneInputRef = useRef(null);
const [formData, setFormData] = useState({
fullName: '',
email: '',
password: '',
userName: '',
userType: '',
userSubType: '',
city: '',
state: '',
country: '',
birthday: '',
industry: '',
profilePhoto: null,
gender: '',
isInBand: false,
selectedBands: [],
startedLearningYear: '',
overallExperienceYears: null,
startedProfessionalYear: '',
professionalExperienceYears: null,
phoneNumber: ''
});
// Calculate experience years when year fields change
useEffect(() => {
const currentYear = new Date().getFullYear();
if (formData.startedLearningYear) {
  const overallYears = currentYear - parseInt(formData.startedLearningYear);
  setFormData(prev => ({
    ...prev,
    overallExperienceYears: overallYears >= 0 ? overallYears : null
  }));
}

if (formData.startedProfessionalYear) {
  const professionalYears = currentYear - parseInt(formData.startedProfessionalYear);
  setFormData(prev => ({
    ...prev,
    professionalExperienceYears: professionalYears >= 0 ? professionalYears : null
  }));
}
}, [formData.startedLearningYear, formData.startedProfessionalYear]);


// Close country dropdown when clicking outside
useEffect(() => {
const handleClickOutside = (event) => {
if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
setShowCountryDropdown(false);
}
};
document.addEventListener('mousedown', handleClickOutside);
return () => {
  document.removeEventListener('mousedown', handleClickOutside);
};
}, []);
// Handle OTP input changes
const handleOtpChange = (e, index) => {
const value = e.target.value;
// Only allow numbers
if (value && !/^\d+$/.test(value)) return;

// Update OTP state
const newOtp = [...otp];
newOtp[index] = value;
setOtp(newOtp);

// Auto-focus next input
if (value && index < 5) {
  otpInputRefs.current[index + 1].focus();
}
};
// Handle paste event for OTP
const handleOtpPaste = (e) => {
e.preventDefault();
const pastedData = e.clipboardData.getData('text');
// Check if pasted content is a 6-digit number
if (/^\d{6}$/.test(pastedData)) {
  const digits = pastedData.split('');
  setOtp(digits);
  
  // Focus the last input
  otpInputRefs.current[5].focus();
}
};


const handleInputChange = (e) => {
const { name, value } = e.target;
setFormData(prev => ({
...prev,
[name]: value
}));
// Reset dependent fields when industry or userType changes
if (name === 'industry') {
  setFormData(prev => ({
    ...prev,
    userType: '',
    userSubType: '',
    startedLearningYear: '',
    startedProfessionalYear: '',
    overallExperienceYears: null,
    professionalExperienceYears: null
  }));
} else if (name === 'userType') {
  setFormData(prev => ({
    ...prev,
    userSubType: '',
    startedLearningYear: '',
    startedProfessionalYear: '',
    overallExperienceYears: null,
    professionalExperienceYears: null
  }));
} else if (name === 'userSubType') {
  setFormData(prev => ({
    ...prev,
    startedLearningYear: '',
    startedProfessionalYear: '',
    overallExperienceYears: null,
    professionalExperienceYears: null
  }));
}
};


const handlePhoneChange = (e) => {
const value = e.target.value;
// Only allow numbers
if (value && !/^\d+$/.test(value)) return;

setPhoneNumber(value);
};


const handleFileChange = (e) => {
if (e.target.files[0]) {
const file = e.target.files[0];
if (file.size > 5 * 1024 * 1024) { // 5MB limit
setError('Image size should be less than 5MB');
return;
}
setFormData(prev => ({
...prev,
profilePhoto: file
}));
}
};


const selectCountry = (country) => {
setSelectedCountry(country);
setShowCountryDropdown(false);
phoneInputRef.current?.focus();
};


const validateUsername = (username) => {
const regex = /^[a-z0-9_]+$/;
return regex.test(username);
};
const validateStep = async () => {
try {
switch (currentStep) {
case 1:
if (!formData.fullName || !formData.gender || !formData.birthday) {
throw new Error('Please fill in all required fields');
}
if (!formData.city || !formData.state || !formData.country) {
throw new Error('Please provide your location details');
}
break;
case 2:
if (!formData.userName) {
throw new Error('Username is required');
}
if (!validateUsername(formData.userName)) {
throw new Error('Username can only contain lowercase letters, numbers, and underscores');
}
const isUnique = await checkUsernameUniqueness(formData.userName);
if (!isUnique) {
throw new Error('Username is already taken');
}
if (!formData.industry || !formData.userType) {
throw new Error('Please select industry and user type');
}
if (!formData.userSubType) {
throw new Error('Please select your sub type');
}
if (formData.userSubType && !formData.startedLearningYear) {
throw new Error('Please select when you first started in this field');
}
if (formData.userSubType && !formData.startedProfessionalYear) {
throw new Error('Please select when you started professionally in this field');
}
break;
case 3:
if (!phoneNumber || phoneNumber.length < 6) {
throw new Error('Please enter a valid phone number');
}
if (!formData.password) {
throw new Error('Password is required');
}
if (formData.password.length < 6) {
throw new Error('Password must be at least 6 characters long');
}
break;
case 4: // OTP verification step
if (otp.join('').length !== 6) {
throw new Error('Please enter the complete 6-digit verification code');
}
break;
default:
return true;
}
return true;
} catch (error) {
setError(error.message);
return false;
}
};
const handleNext = async () => {
const isValid = await validateStep();
if (isValid) {
if (currentStep === 3) {
// Send OTP before moving to verification step
await sendOTP();
} else {
setCurrentStep(prev => prev + 1);
setError('');
}
}
};
const handleBack = () => {
setCurrentStep(prev => prev - 1);
setError('');
};


const sendOTP = async () => {
setIsLoading(true);
setError('');
try {
  // Format phone number for the API
  const formattedNumber = `${selectedCountry.code}${phoneNumber}`;
  
  // Get Firebase Functions instance
  const functions = getFunctions();
  
  // Call Firebase function to send OTP
  const sendOTPFunction = httpsCallable(functions, 'sendOTP');
  const result = await sendOTPFunction({ phoneNumber: formattedNumber });
  
  // Parse response
  const response = result.data;
  
  if (response.success) {
    // Move to OTP verification step
    setCurrentStep(4);
    
    // Reset OTP input fields
    setOtp(['', '', '', '', '', '']);
    
    // Focus first OTP input
    setTimeout(() => {
      otpInputRefs.current[0]?.focus();
    }, 100);
  } else {
    setError(response.message || 'Failed to send verification code');
  }
} catch (error) {
  console.error('Error sending OTP:', error);
  setError('Failed to send verification code. Please try again.');
} finally {
  setIsLoading(false);
}
};


const verifyOTP = async () => {
setIsLoading(true);
setError('');
try {
  const otpValue = otp.join('');
  
  // Format phone number for the API
  const formattedNumber = `${selectedCountry.code}${phoneNumber}`;
  
  // Get Firebase Functions instance
  const functions = getFunctions();
  
  // Call Firebase function to verify OTP
  const verifyOTPFunction = httpsCallable(functions, 'verifyOTP');
  const result = await verifyOTPFunction({ 
    phoneNumber: formattedNumber,
    otp: otpValue
  });
  
  // Parse response
  const response = result.data;
  
  if (response.success) {
    // Update formData with verified phone number
    setFormData(prev => ({
      ...prev,
      phoneNumber: formattedNumber
    }));
    
    // Create user account
    await handleCreateAccount();
  } else {
    setError(response.message || 'Invalid verification code');
  }
} catch (error) {
  console.error('Error verifying OTP:', error);
  setError('Failed to verify code. Please try again.');
} finally {
  setIsLoading(false);
}
};

const handleCreateAccount = async () => {
setIsLoading(true);
setError('');
try {
  // Format phone number for storage
  const formattedNumber = `${selectedCountry.code}${phoneNumber}`;
  
  let profilePictureUrl = '';
  const result = await signUp({
    ...formData,
    phoneNumber: formattedNumber,
    profilePictureUrl
  });

  if (formData.profilePhoto) {
    profilePictureUrl = await uploadProfilePhoto(formData.profilePhoto, result.user.uid);
  }

  alert('Account created successfully!');
  navigate('/login');
} catch (error) {
  setError(error.message);
} finally {
  setIsLoading(false);
}
};
const renderStep = () => {
switch (currentStep) {
case 1:
return (
<>
<div className={styles['profile-photo-section']}>
<img
src={formData.profilePhoto ? URL.createObjectURL(formData.profilePhoto) : defaultUserProfilePicture}
alt="Profile"
className={styles['profile-photo']}
/>
<label className={styles['upload-button']}>
<FiCamera /> Upload Photo
<input
               type="file"
               hidden
               accept="image/*"
               onChange={handleFileChange}
             />
</label>
</div>
        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleInputChange}
            className={styles['form-input']}
            placeholder="Enter your full name"
          />
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Gender</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className={styles['select-input']}
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Birthday</label>
          <input
            type="date"
            name="birthday"
            value={formData.birthday}
            onChange={handleInputChange}
            className={styles['form-input']}
          />
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>City</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
            className={styles['form-input']}
            placeholder="Enter your city"
          />
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>State</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleInputChange}
            className={styles['form-input']}
            placeholder="Enter your state"
          />
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Country</label>
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleInputChange}
            className={styles['form-input']}
            placeholder="Enter your country"
          />
        </div>
      </>
    );

  case 2:
    return (
      <>
        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Username</label>
          <input
            type="text"
            name="userName"
            value={formData.userName}
            onChange={handleInputChange}
            className={styles['form-input']}
            placeholder="Choose a username"
          />
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Industry</label>
          <select
            name="industry"
            value={formData.industry}
            onChange={handleInputChange}
            className={styles['select-input']}
          >
            <option value="">Select Industry</option>
            {INDUSTRY_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {formData.industry && (
          <div className={styles['form-group']}>
            <label className={styles['form-label']}>User Type</label>
            <select
              name="userType"
              value={formData.userType}
              onChange={handleInputChange}
              className={styles['select-input']}
            >
              <option value="">Select User Type</option>
              {USER_TYPE_OPTIONS[formData.industry]?.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {formData.industry && formData.userType && (
          <div className={styles['form-group']}>
            <label className={styles['form-label']}>Sub Type</label>
            <select
              name="userSubType"
              value={formData.userSubType}
              onChange={handleInputChange}
              className={styles['select-input']}
            >
              <option value="">Select Sub Type</option>
              {USER_SUBTYPE_OPTIONS[formData.industry]?.[formData.userType]?.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {formData.userSubType && (
          <>
            <div className={styles['form-group']}>
              <label className={styles['form-label']}>
                When did you first start {getActivityVerb(formData.userSubType)}?
              </label>
              <select
                name="startedLearningYear"
                value={formData.startedLearningYear}
                onChange={handleInputChange}
                className={styles['select-input']}
              >
                <option value="">Select Year</option>
                {generateYearOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {formData.overallExperienceYears !== null && (
                <div className={styles['calculated-years']}>
                  Overall years: {formData.overallExperienceYears}
                </div>
              )}
            </div>

            <div className={styles['form-group']}>
              <label className={styles['form-label']}>
                When did you start {getActivityVerb(formData.userSubType)} professionally?
              </label>
              <select
                name="startedProfessionalYear"
                value={formData.startedProfessionalYear}
                onChange={handleInputChange}
                className={styles['select-input']}
              >
                <option value="">Select Year</option>
                {generateYearOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {formData.professionalExperienceYears !== null && (
                <div className={styles['calculated-years']}>
                  Professional experience: {formData.professionalExperienceYears} years
                </div>
              )}
            </div>
          </>
        )}

        {formData.userType === 'Artist' && (
          <div className={styles['form-group']}>
            <label className={styles['form-label']}>Are you in any bands?</label>
            <div className={styles['radio-group']}>
              <label className={styles['radio-button']}>
                <input
                  type="radio"
                  name="isInBand"
                  checked={formData.isInBand === true}
                  onChange={() => setFormData(prev => ({ ...prev, isInBand: true }))}
                />
                Yes
              </label>
              <label className={styles['radio-button']}>
                <input
                  type="radio"
                  name="isInBand"
                  checked={formData.isInBand === false}
                  onChange={() => setFormData(prev => ({ ...prev, isInBand: false }))}
                />
                No
              </label>
            </div>
          </div>
        )}
      </>
    );

  case 3: // Phone number and password
    return (
      <>
        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Phone Number</label>
          <div className={styles['phone-input-container']}>
            {/* Country code dropdown */}
            <div className={styles['country-dropdown']} ref={countryDropdownRef}>
              <button 
                type="button"
                className={styles['country-button']}
                onClick={() => setShowCountryDropdown(!showCountryDropdown)}
              >
                <span className={styles['country-flag']}>{selectedCountry.flag}</span>
                <span className={styles['country-code']}>{selectedCountry.code}</span>
                <span className={styles['dropdown-arrow']}>▼</span>
              </button>
              
              {showCountryDropdown && (
                <div className={styles['dropdown-menu']}>
                  <div className={styles['dropdown-search']}>
                    <input 
                      type="text" 
                      placeholder="Search countries..."
                      className={styles['dropdown-search-input']}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        // Could implement search functionality here
                      }}
                    />
                  </div>
                  <div className={styles['dropdown-list']}>
                    {sortedCountryCodes.map((country, index) => (
                      <div 
                        key={index} 
                        className={styles['dropdown-item']}
                        onClick={() => selectCountry(country)}
                      >
                        <span className={styles['country-flag']}>{country.flag}</span>
                        <span className={styles['country-code']}>{country.code}</span>
                        <span className={styles['country-name']}>{country.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            {/* Phone number input */}
            <input
              ref={phoneInputRef}
              type="tel"
              value={phoneNumber}
              onChange={handlePhoneChange}
              className={styles['phone-input']}
              placeholder="Enter phone number"
            />
          </div>
        </div>

        <div className={styles['form-group']}>
          <label className={styles['form-label']}>Password</label>
          <div className={styles['password-input-container']}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={styles['form-input']}
              placeholder="Create a password"
            />
            <button
              type="button"
              className={styles['password-toggle']}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>
      </>
    );

  case 4: // OTP verification
    return (
      <>
        <div className={styles['otp-heading']}>
          <h3>Phone Verification</h3>
          <p>We've sent a verification code to <span>{selectedCountry.code} {phoneNumber}</span></p>
        </div>
        
        <div className={styles['otp-container']}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (otpInputRefs.current[index] = el)}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e, index)}
              onPaste={index === 0 ? handleOtpPaste : null}
              className={styles['otp-input']}
              autoFocus={index === 0}
            />
          ))}
        </div>
        
        <div className={styles['resend-otp']}>
          <p>Didn't receive the code? <button 
            type="button" 
            onClick={sendOTP} 
            disabled={isLoading}
            className={styles['resend-button']}
          >
            Resend
          </button></p>
        </div>
      </>
    );

  default:
    return null;
}
};
return (
<div className={styles['signup-page']}>
<div className={styles['signup-container']}>
<div className={styles['logo-section']}>
<img src={logo} alt="On Tour Logo" className={styles.logo} />
<h1>Create Account</h1>
</div>
    <div className={styles['step-indicator']}>
      {[1, 2, 3, 4].map(step => (
        <div
          key={step}
          className={`${styles.step} ${currentStep === step ? styles.active : ''} 
            ${currentStep > step ? styles.completed : ''}`}
        >
          {currentStep > step ? <FiCheck /> : step}
        </div>
      ))}
    </div>

    <div className={styles['form-container']}>
      {error && <div className={styles['error-message']}>{error}</div>}
      
      <form onSubmit={(e) => e.preventDefault()}>
        {renderStep()}

        <div className={styles['navigation-buttons']}>
          {currentStep > 1 && (
            <button 
              type="button" 
              className={styles['back-button']}
              onClick={handleBack}
              disabled={isLoading}
            >
              <FiArrowLeft /> Back
            </button>
          )}
          
          {currentStep < 4 && (
            <button
              type="button"
              className={styles['next-button']}
              onClick={handleNext}
              disabled={isLoading}
            >
              {currentStep === 3 && isLoading ? 'Sending...' : (
                <>
                  {currentStep === 3 ? 'Send Verification' : 'Next'} <FiArrowRight />
                </>
              )}
            </button>
          )}
          
          {currentStep === 4 && (
            <button
              type="button"
              className={styles['next-button']}
              onClick={verifyOTP}
              disabled={isLoading || otp.join('').length !== 6}
            >
              {isLoading ? 'Verifying...' : 'Verify & Create Account'}
            </button>
          )}
        </div>
      </form>
    </div>

    <div className={styles['login-link']}>
      Already have an account? <Link to="/login">Login</Link>
    </div>
  </div>
</div>
);
};
export default SignupPage;